import type React from 'react';
import { useEffect, useRef } from 'react';

export const Lightbox = (props: React.PropsWithChildren) => {
    const { children } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.body.classList.add('overflow-hidden', 'relative', 'h-full', 'bg-[var(--w-white)]');

        return () => document.body.classList.remove('overflow-hidden', 'relative', 'h-full', 'bg-[var(--w-white)]');
    }, []);

    const backdropClassName = 's-bg-inverted fixed items-center inset-0 place-items-center z-20 overflow-hidden full-width-tabs';

    return (
        <div ref={contentRef} className={backdropClassName} aria-modal="true" role="dialog" data-testid="lightbox">
            {children}
        </div>
    );
};
